export default __webpack_public_path__ + "static/media/Login.1fed8941.png";